import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// import App from "App";
import "bootstrap/dist/css/bootstrap.min.css";
import { MaterialUIControllerProvider } from "context";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
const container = document.getElementById("app");
const root = createRoot(container);
const App = React.lazy(() => import("./App"));

const stripePromise = loadStripe("pk_live_GwaYx2OJ9OWkK0GbAGOkzuXx00jaaB54Ml");

const appearance = {
  theme: "stripe",
};

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      {/* <Suspense
        fallback={
          <div className="loader-wrapper">
            <div className="custom-loader"></div>
          </div>
        }
      > */}
      <Elements stripe={stripePromise} options={{ appearance }}>
        <App />
      </Elements>
      {/* </Suspense> */}
    </MaterialUIControllerProvider>
  </BrowserRouter>,
);
